import { checkLegalEntityFieldUniquenessUseCase } from '@webapp/platform/legal-entities/business-logic/use-cases/CheckLegalEntityFieldUniqueness'
import { type LegalEntity } from '@webapp/platform/legal-entities/entities/LegalEntity'
import { useQueryLegalEntityUniqueFields } from '@webapp/platform/legal-entities/hooks/useQueryLegalEntityUniqueFields'

/**
 * Wires the existing name/external-ID query to the pure uniqueness use case and
 * exposes the two inline-validation checks, so create/edit presenters don't
 * plumb the raw lists themselves.
 *
 * Pass the `entity` being edited so its own name/external ID is allowed
 * (excluded from the check); omit it on create.
 */
export const useLegalEntityUniquenessChecks = (entity?: LegalEntity) => {
  const { names, externalIds } = useQueryLegalEntityUniqueFields()

  const isNameTaken = (name: string) =>
    checkLegalEntityFieldUniquenessUseCase({
      value: name,
      existingValues: names,
      currentValue: entity?.name,
    })

  const isExternalIdTaken = (externalId: string) =>
    checkLegalEntityFieldUniquenessUseCase({
      value: externalId,
      existingValues: externalIds,
      currentValue: entity?.externalId,
    })

  return { isNameTaken, isExternalIdTaken }
}
